import { SquadAbsenceReason, SquadPosition } from '../interfaces/squad.interface';

export const SQUAD_CONSTANTS = {
    /** Display order of the position groups; i18n keys live under `squad.positions.<POSITION>`. */
    POSITIONS: ['GK', 'DEF', 'MID', 'FWD'] as SquadPosition[],
    /** Absence reasons in menu order, with their feather icon; i18n keys live under `squad.absence.reasons`. */
    ABSENCE_REASONS: ['injured', 'vacation', 'suspended', 'other'] as SquadAbsenceReason[],
    ABSENCE_ICONS: {
        injured: 'plus-square',
        vacation: 'sun',
        suspended: 'slash',
        other: 'minus-circle',
    } as Record<SquadAbsenceReason, string>,
    DEFAULT_POSITION: 'MID' as SquadPosition,
    NAME_MAX_LENGTH: 50,
    /** How long a moved row stays highlighted. */
    HIGHLIGHT_MS: 500,
};
